// Types
import { EAutomatedEmailFilterGroupId } from '~/modules/opportunities/automated-email/settings/types';

/** Maps each display group to the modal tab it should open (Property/Data/Consent). */
const GROUP_TAB_INDEX: Record<EAutomatedEmailFilterGroupId, number> = {
  [EAutomatedEmailFilterGroupId.PROPERTY]: 0,
  [EAutomatedEmailFilterGroupId.DATA]: 1,
  [EAutomatedEmailFilterGroupId.CONSENT]: 2,
};

export { GROUP_TAB_INDEX };
